import React, { Component } from 'react';
import { FitToWindow, connect, screen, ScreenRouter } from 'dooh-react-utils';
import * as screens from './screens';

const SCREENS = [
  screen(screens.IntroScreen, 'intro', {}),
  screen(screens.GameScreen, 'game', {}),
  screen(screens.GameLostScreen, 'game_lost', {timeout: 5000}),
  screen(screens.GameWonScreen, 'game_won', {timeout: 10000}),
  screen(screens.FormScreen, 'form', {timeout: 20000}),
  screen(screens.ThanksScreen, 'thanks', {timeout: 5000}),
];


class App extends Component {
  render() {
    return (
      <FitToWindow width={1080} height={1920} fit={true} className="App">
        <ScreenRouter
          screen={this.props.screen}
          screens={SCREENS}
          hiddenBack={false}
          update={this.props.update}
          screenProps={Object.assign({}, this.props)}
        />
      </FitToWindow>
    );
  }
}

export default connect(App);




// WEBPACK FOOTER //
// ./src/App.js